var exports = {
  "kL": "x2b2fbebb--690342--container",
  "wx": "x2b2fbebb--690342--header",
  "AS": "x2b2fbebb--690342--item",
  "DD": "x2b2fbebb--690342--title",
  "Qs": "x2b2fbebb--690342--content",
};

module.exports = exports;
